export default __webpack_public_path__ + "static/Entenda0034-a08ca87f68998be30090f6fc3be27c06.jpg";